/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnsurePatientInRxntResponseDto
 */
export interface EnsurePatientInRxntResponseDto {
    /**
     * Indicates if the patient is registered in medication provider successfully
     * @type {boolean}
     * @memberof EnsurePatientInRxntResponseDto
     */
    success: boolean;
    /**
     * Success message
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    message: string;
    /**
     * The chart number assigned to the patient
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    rxntChartNumber: string;
    /**
     * The RXNT doctor ID from practice configuration
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    rxntDoctorId: string;
    /**
     * The prescription order ID for RXNT medications
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    prescriptionOrderId: string;
    /**
     * The patient ID in Cellera system
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    patientId: string;
    /**
     * Provider address line 1 (used for RXNT patient address)
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    providerAddress1?: string;
    /**
     * Provider city (used for RXNT patient address)
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    providerCity?: string;
    /**
     * Provider state (used for RXNT patient address)
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    providerState?: string;
    /**
     * Provider ZIP code (used for RXNT patient address)
     * @type {string}
     * @memberof EnsurePatientInRxntResponseDto
     */
    providerZip?: string;
}

/**
 * Check if a given object implements the EnsurePatientInRxntResponseDto interface.
 */
export function instanceOfEnsurePatientInRxntResponseDto(value: object): value is EnsurePatientInRxntResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('rxntChartNumber' in value) || value['rxntChartNumber'] === undefined) return false;
    if (!('rxntDoctorId' in value) || value['rxntDoctorId'] === undefined) return false;
    if (!('prescriptionOrderId' in value) || value['prescriptionOrderId'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    return true;
}

export function EnsurePatientInRxntResponseDtoFromJSON(json: any): EnsurePatientInRxntResponseDto {
    return EnsurePatientInRxntResponseDtoFromJSONTyped(json, false);
}

export function EnsurePatientInRxntResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnsurePatientInRxntResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'rxntChartNumber': json['rxntChartNumber'],
        'rxntDoctorId': json['rxntDoctorId'],
        'prescriptionOrderId': json['prescriptionOrderId'],
        'patientId': json['patientId'],
        'providerAddress1': json['providerAddress1'] == null ? undefined : json['providerAddress1'],
        'providerCity': json['providerCity'] == null ? undefined : json['providerCity'],
        'providerState': json['providerState'] == null ? undefined : json['providerState'],
        'providerZip': json['providerZip'] == null ? undefined : json['providerZip'],
    };
}

export function EnsurePatientInRxntResponseDtoToJSON(json: any): EnsurePatientInRxntResponseDto {
    return EnsurePatientInRxntResponseDtoToJSONTyped(json, false);
}

export function EnsurePatientInRxntResponseDtoToJSONTyped(value?: EnsurePatientInRxntResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'rxntChartNumber': value['rxntChartNumber'],
        'rxntDoctorId': value['rxntDoctorId'],
        'prescriptionOrderId': value['prescriptionOrderId'],
        'patientId': value['patientId'],
        'providerAddress1': value['providerAddress1'],
        'providerCity': value['providerCity'],
        'providerState': value['providerState'],
        'providerZip': value['providerZip'],
    };
}

